import Label from './Label';
import useWhatsappBadgeCount from '../hooks/useWhatsappBadgeCount';

/**
 * Renders a red badge showing the count of unread WhatsApp messages.
 * Used as the `info` prop on the WhatsApp nav item in NavConfig.
 * Returns null when count is 0 or whatsapp-messaging is not enabled.
 */
export default function WhatsappBadge() {
    const count = useWhatsappBadgeCount();

    if (!count) return null;

    return (
        <Label
            color="error"
            variant="filled"
            sx={{
                borderRadius: '10px',
                fontSize: '10px',
                height: 18,
                minWidth: 18,
                px: 0.5,
            }}
        >
            {count > 99 ? '99+' : count}
        </Label>
    );
}
